'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SeeMoreItems = require('./SeeMoreItems.scss');

var _SeeMoreItems2 = _interopRequireDefault(_SeeMoreItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SeeMoreItems = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(SeeMoreItems, _Component);

    function SeeMoreItems(props, context) {
        (0, _classCallCheck3.default)(this, SeeMoreItems);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SeeMoreItems.__proto__ || (0, _getPrototypeOf2.default)(SeeMoreItems)).call(this, props, context));

        _this.onSeeLess = function () {
            _this.changeSeeMore();
            _this.props.onSeeLessItemsClick();
        };

        _this.onSeeMore = function () {
            _this.changeSeeMore();
            _this.props.onSeeMoreItemsClick();
        };

        _this.changeSeeMore = function () {
            var seeMore = !_this.state.seeMore;
            _this.setState({ seeMore: seeMore });
        };

        _this.state = {
            seeMore: false
        };
        return _this;
    }

    (0, _createClass3.default)(SeeMoreItems, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.items.length !== nextProps.items.length) {
                this.setState({ seeMore: false });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'hideSeeLess', 'items', 'linkClassName', 'seeLessFormattedMessageId', 'seeMoreFormattedMessageId', 'showItemCount']) || (0, _propsComparer2.default)(this.state, nextState, ['seeMore']);
        }
    }, {
        key: 'render',
        value: function render() {
            var seeMore = this.state.seeMore;
            var _props = this.props,
                className = _props.className,
                hideSeeLess = _props.hideSeeLess,
                items = _props.items,
                linkClassName = _props.linkClassName,
                seeLessFormattedMessageId = _props.seeLessFormattedMessageId,
                seeMoreFormattedMessageId = _props.seeMoreFormattedMessageId,
                showItemCount = _props.showItemCount;


            var slicedItems = seeMore ? items : items.slice(0, showItemCount);
            var linkClasses = [].concat((0, _toConsumableArray3.default)(linkClassName.split(' ')), [_SeeMoreItems2.default.seemore]).join(' ').trim();
            var showSeeMore = items.length > showItemCount && !seeMore;
            var showSeeLess = !showSeeMore && !hideSeeLess && items.length > showItemCount;
            return (0, _jsx3.default)('div', {
                className: className
            }, void 0, slicedItems, showSeeMore && (0, _jsx3.default)(_components.Link, {
                className: linkClasses,
                onClick: this.onSeeMore
            }, 'see-more', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: seeMoreFormattedMessageId
            })), showSeeLess && (0, _jsx3.default)(_components.Link, {
                className: linkClasses,
                onClick: this.onSeeMore
            }, 'see-less', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: seeLessFormattedMessageId
            })));
        }
    }]);
    return SeeMoreItems;
}(_react.Component), _class.defaultProps = {
    className: '',
    hideSeeLess: false,
    linkClassName: '',
    onSeeLessItemsClick: _noop2.default,
    onSeeMoreItemsClick: _noop2.default,
    seeLessFormattedMessageId: 'search_see_less',
    seeMoreFormattedMessageId: 'search_see_all'
}, _temp);
exports.default = SeeMoreItems;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SeeMoreItems/SeeMoreItems.js
// module id = awYM
// module chunks = 57